"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('convertRange'),
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
    zod_1.z.object({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('extractValues'),
        extract: zod_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('convertRange'),
    }),
    zod_1.z.object({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('extractValues'),
        extract: zod_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
    }),
]);
exports.nodeType = 'operation_xlsx2csv';
//# sourceMappingURL=types.js.map